import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Radium from 'radium';
import { greyScaleColors, semanticColors } from '../../Globals/styles';
import { absenceCodes } from '../../Globals/constants';
import NumberInput from '../../Common/numberInput';
import Selectpicker from '../../Common/selectpicker';

import auth from '../../Login/authService'

class Calculator extends Component {
  constructor(props) {
    super(props);
    let absenceCodesForState = Object.keys(absenceCodes).map((absenceCode) => {return {id: absenceCode, name: absenceCodes[absenceCode]}})
    absenceCodesForState.splice(0, 0, {id: "0", name: "Ingen fravær"})
    this.state = {
      normalHours: this.props.normalHours,
      supplementHours: this.props.supplementHours,
      supplementRate: this.props.supplementRate===0 ? this.props.lastestSupplementRate : this.props.supplementRate,
      absenceCodes: absenceCodesForState,
      absenceCode: this.props.absenceCode,
      forceFocus: this.props.normalHours===0 ? true : false,
      mileageNew: this.props.mileageNew,
      shackNew: this.props.shackNew
    }
  }

  calculateSuppliment = () => {
    return (this.state.supplementHours * this.state.supplementRate);
  };
  submit = () => {
    const { updateDay, setOpenCalculator, id } = this.props;
    updateDay(id, this.state.normalHours, this.state.supplementRate, this.state.supplementHours, this.state.mileageNew, this.state.shackNew, this.state.absenceCode)
    setOpenCalculator("");
  };
  onAbsenceCodeChange = (val) => {
    if (val==="0")
      val = null;
    if(val!==this.props.absenceCode){
      this.setState({
        absenceCode: val
      })
    }
  };

	render() {
    const { id, setOpenCalculator, normalHoursOrig, nightHoursOrig, onSaveClick, shack, mileage, conflictNodes, workplaces } = this.props;

    let token = auth.getToken()
    let requestObjectString = JSON.stringify({salaryId: id.replace(/&/g, "_"), token})
    let link = process.env.REACT_APP_webApiEndPoint + "api/dailyreport/printmultiple/?request=" + requestObjectString;

		return (
			<div style={styles.container}>
        <i
          className="fa fa-times waves-icon"
          style={styles.closebutton}
          onClick={() => setOpenCalculator("")}
          aria-hidden="true"></i>
        <div style={styles.header}>
          <div style={styles.leftContent}>
            <i className="fa fa-sun-o" aria-hidden="true" style={styles.marginRight}></i>
            <div style={styles.normalHoursOrig}>{normalHoursOrig}</div>
          </div>
          <div style={styles.rightContent}>
            <i className="fa fa-moon-o" aria-hidden="true" style={styles.marginRight}></i>
            <div style={styles.nightHoursOrig}>{nightHoursOrig}</div>
          </div>
        </div>

        <div style={styles.row}>
          <div style={styles.leftContent}>
            Normal timer
          </div>
          <div style={styles.rightContent}>
            <NumberInput
              forceFocus={this.state.forceFocus}
              style={styles.numberInput}
              defaultValue={this.state.normalHours}
              value={this.state.normalHours}
              onChange={(val) => this.setState({normalHours: val})}
              onEnterPress={onSaveClick}
            />
          </div>
        </div>
        <div style={styles.boxContent}>
          <div style={styles.leftContent}>
            Tilæg
          </div>
          <div style={[styles.rightContent, styles.supplement]}>
            {this.calculateSuppliment()}kr
          </div>
        </div>

        <div style={styles.row}>
          <div style={styles.leftContent}>
            <NumberInput
              style={styles.numberInput}
              defaultValue={this.state.supplementHours}
              value={this.state.supplementHours}
              onChange={(val) => this.setState({supplementHours: val})}
              onEnterPress={onSaveClick}
            />
          </div>
          <div style={styles.rightContent}>
            <NumberInput
              style={styles.numberInput}
              defaultValue={this.state.supplementRate}
              value={this.state.supplementRate}
              onChange={(val) => this.setState({supplementRate: val})}
              onEnterPress={onSaveClick}
            />
          </div>
        </div>



        <Selectpicker
          onChange={this.onAbsenceCodeChange}
          items={this.state.absenceCodes}
          defaultValue={this.state.absenceCode}
        />

        <div style={styles.mileShackRow}>
          <div style={styles.mileShackRowLeft}>
            <div style={styles.mileShackRowPad}><span className="pull-left">Skur</span>{shack ? 1 : 0}</div>
            <div>
              <NumberInput
                style={styles.numberInput}
                defaultValue={this.state.shackNew}
                value={this.state.shackNew}
                onChange={(val) => this.setState({shackNew: val})}
                onEnterPress={onSaveClick}
              />
            </div>
          </div>
          <div style={styles.mileShackRowRight}>
            <div style={styles.mileShackRowPad}><span className="pull-left">Kørsel</span>{mileage}</div>
            <div>
              <NumberInput
                style={styles.numberInput}
                defaultValue={this.state.mileageNew}
                value={this.state.mileageNew}
                onChange={(val) => this.setState({mileageNew: val})}
                onEnterPress={onSaveClick}
              />
            </div>
          </div>
        </div>
        {workplaces.length > 0 ?
          <a
            href={link}
            className="btn btn-default"
            target="_blank" rel="noopener noreferrer"
            style={styles.printButton}>Vis dagrapporter</a> : null
        }

        { conflictNodes.length ?
          <div style={styles.conflictprojBox}>
             {conflictNodes}
          </div>
          : null
        }
      </div>
		);
	}
}

var styles = {
  mileShackRow: {
    marginTop: '8px',
    textAlign: 'right'
  },
  mileShackRowPad:{
    paddingRight: '12px'
  },
  mileShackRowLeft: {
    width: '55px',
    float: 'left'
  },
  mileShackRowRight: {
    width: '85px',
    float: 'right'
  },
  container: {
    position: 'absolute',
    padding: '10px',
    top: '-88px',
    minHeight: '270px',
    left: '77px',
    width: '180px',
    backgroundColor: "#F7F7F7",
    zIndex: '2',
    fontSize: '12px',
    borderRadius: '2px',
    boxShadow: '0 0px 1px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)'
  },
  closebutton: {
    float: 'right',
    height: '20px',
    lineHeight : '20px',
    width: '20px',
    fontSize: '20px'
  },
  header: {
    height: '30px',
    textAlign: 'center',
    fontWeight: '600',
    marginBottom: '10px',
    borderBottom: '1px solid ' + semanticColors.mainBackground
  },
  td:{
    width: '25%',
    padding: '1px'
  },
  row: {
    marginBottom: '10px',
    height: '35px'
  },
  boxContent: {
    height: '25px'
  },
  leftContent: {
    width: '65px',
    float: 'left',
    textAlign: 'left'
  },
  rightContent: {
    width: '65px',
    float: 'right',
    textAlign: 'left'
  },
  marginRight: {
    marginRight: '25px',
    fontSize: '20px',
    color: greyScaleColors.greyLight
  },
  numberInput: {
    height: '35px',
    border: 'none',
    boxShadow: '0 1px 2px rgba(0,0,0,0.2) inset, 0 -1px 0 rgba(0,0,0,0.05) inset',
    borderRadius: '2px'
  },
  normalHoursOrig: {
    display: 'block',
    position: 'absolute',
    top: '13px',
    left: '46px'
  },
  nightHoursOrig: {
    display: 'block',
    position: 'absolute',
    top: '13px',
    right: '46px'
  },
  supplement:{
    textAlign: 'right'
  },
  textRight: {
    textAlign: 'right'
  },
  textLeft: {
    textAlign: 'left'
  },
  conflictprojBox:{
    minHeight: '20px',
    width: '100%',
    marginTop: '10px',
    display: 'inline-block',
    borderTop: '1px solid ' + semanticColors.mainBackground
  },
  printButton: {
    width: '100%',
    marginTop: '8px'
  }
}
	Calculator.propTypes = {
    id: PropTypes.string.isRequired,
    absenceCode: PropTypes.string,
    conflictsWith: PropTypes.array.isRequired,
    isConflicting: PropTypes.bool.isRequired,
    nightHoursOrig: PropTypes.number.isRequired,
    normalHours: PropTypes.number.isRequired,
    normalHoursOrig: PropTypes.number.isRequired,
    supplementRate: PropTypes.number.isRequired,
    supplementHours: PropTypes.number.isRequired,
    setOpenCalculator: PropTypes.func.isRequired,
    mileage: PropTypes.number.isRequired,
    shack: PropTypes.bool.isRequired,
    mileageNew: PropTypes.number.isRequired,
    shackNew: PropTypes.number.isRequired,
    employeeWage: PropTypes.string.isRequired,
    updateDay: PropTypes.func.isRequired,
    latestSupplementRate: PropTypes.number.isRequired,
    conflictNodes: PropTypes.arrayOf(PropTypes.object).isRequired
  };
export default Radium(Calculator)


// WEBPACK FOOTER //
// ./src/App/Project/Salary/calculator.jsx